import { useCapabilities } from "../api/hooks.js";
import { Empty, PageState } from "../components/PageState.js";
export function ProfilesPage({ deviceId }: { deviceId: string }) {
  const caps = useCapabilities(deviceId);
  const cap = caps.data?.find((c) => c.capability === "local_restrictions");
  let profiles: { user_id: number; name: string; active: boolean }[] = [];
  try {
    profiles = JSON.parse(cap?.notes ?? "{}").profiles ?? [];
  } catch {
    /* No report */
  }
  const fresh =
    !!cap && Date.now() - new Date(cap.checked_at).getTime() < 120000;
  if (!deviceId) return <Empty label="Select a headset to see its profiles." />;
  return (
    <PageState query={caps}>
      <section className="card stack">
        <h2>Who’s using this Quest?</h2>
        <p className="muted">
          Profiles are discovered from the headset. Add or switch a Meta profile
          on the Quest; its next online report updates this list.
        </p>
        <div className="notice">
          Current rules apply to <strong>everyone on this headset</strong>.
          Separate limits for each person are not available yet.
        </div>
      </section>
      {!profiles.length ? (
        <Empty label="No profile report yet. Wake the headset and connect it to the internet." />
      ) : (
        <div className="game-grid">
          {profiles.map((p) => (
            <article className="card game-card" key={p.user_id}>
              <div className="game-avatar">
                {p.name.slice(0, 1).toUpperCase()}
              </div>
              <div className="game-body">
                <h3>{p.name}</h3>
                <span
                  className={`badge ${fresh && p.active ? "ok" : "pending"}`}
                >
                  {fresh
                    ? p.active
                      ? "Active profile"
                      : "On this headset"
                    : "Last reported"}
                </span>
                <p className="muted">
                  Uses the headset’s shared rules and allowance.
                </p>
              </div>
            </article>
          ))}
        </div>
      )}
      <p className="muted">
        {cap
          ? `Last update: ${new Date(cap.checked_at).toLocaleString()}.`
          : "Waiting for a report."}{" "}
        Profile discovery is experimental; additional profiles have not yet been
        tested on this headset.
      </p>
    </PageState>
  );
}
